import { useState } from "react";
import Modal from "react-modal";
import InputMask from "react-input-mask";
import { MainButton } from "../MainButton";
import { useNavigate, useParams } from "react-router-dom";
import { useSeller } from "../../hooks/useSeller";
import { cpfCnpjNoMask, telephoneNoMask } from "../../functions/mask";
import { useOrder } from "../../hooks/useOrder";
import Swal from "sweetalert2";
import "./index.css";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { floatToCents } from "../../functions/price_functions";
import { cnpj, cpf } from "cpf-cnpj-validator";

type ModalSellerProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  backgroundButton?: string;
  fontButton?: string;
};

export function ModalSellerSave({
  isOpen,
  setIsOpen,
  backgroundButton,
  fontButton,
}: ModalSellerProps) {
  const [customerCpf, setCustomerCpf] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");

  const [maskCpfjCnpj, setMaskCpfjCnpj] = useState("999.999.999-99");
  const [maskTelephone, setMaskTelephone] = useState("(99) 9999-9999");

  const [alarmCpf, setAlarmCpf] = useState(false);
  const [alarmName, setAlarmName] = useState(false);
  const [alarmPhone, setAlarmPhone] = useState(false);
  const { getOrder, clearOrder, getOrderWithDiscount } = useOrder();

  const navigate = useNavigate();
  const { getTokenSeller, setCustomerToSeller } = useSeller();
  const { pluginspace_id } = useParams();
  const { getToken, pluginspace } = usePluginspace();
  const orderContext = useOrder();

  function changeTelephone(newPhone: string) {
    const phoneValidated = newPhone.replaceAll("_", "");
    if (phoneValidated.length >= 14 && phoneValidated[13] !== "_") {
      setMaskTelephone("(99) 99999-9999");
    } else {
      setMaskTelephone("(99) 9999-9999");
    }
  }

  function changeMaskCpf(newDocument: string) {
    if (newDocument.length >= 14 && newDocument[13] !== "_") {
      setMaskCpfjCnpj("99.999.999/9999-99");
    } else {
      setMaskCpfjCnpj("999.999.999-99");
    }
  }

  async function saveCart() {
    if (customerCpf.length > 14 && customerCpf[13] !== "_") {
      if (!cnpj.isValid(customerCpf)) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Verifique se o CNPJ é válido",
        });
        setAlarmCpf(true);
        return;
      }
    } else {
      if (!cpf.isValid(customerCpf)) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Verifique se o CPF é válido",
        });
        setAlarmCpf(true);
        return;
      }
    }

    if (customerPhone.includes("_")) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Verifique se telefone é válido",
      });
      setAlarmPhone(true);
      return;
    }

    if (
      customerName &&
      customerPhone &&
      !customerPhone.includes("_") &&
      customerCpf &&
      customerCpf[0] != "_"
    ) {
      const tk = getTokenSeller();

      let link = `${window.location.origin}/${
        window.location.pathname.split("/")[1]
      }`;

      if (pluginspace && pluginspace.appLogin) {
        link = `${link}/new_cart`;
      } else {
        link = `${link}/new-cart`;
      }

      const order = await getOrderWithDiscount();
      const jsonCart = {
        products: order.products.map((product: any) => {
          const variation = Object.entries(product.variation).map(
            (variationGrid) => {
              return {
                grid: variationGrid[0],
                valor: variationGrid[1],
              };
            }
          );
          return {
            id: product.id,
            img: product.image,
            sku: product.sku,
            variation: variation,
            name: product.name,
            price: product.unitPrice,
            unitPrice: product.unitPrice,
            discount:
              product.promotionalPrice !== 0 &&
              product.promotionalPrice !== product.unitPrice
                ? product.promotionalPrice - product.unitPrice
                : 0,
            discountGeral:
              product.promotionalPrice !== 0 &&
              product.promotionalPrice !== product.unitPrice
                ? product.promotionalPrice - product.unitPrice
                : 0,
            promotional_price: product.promotionalPrice,
            quantity: product.quantity,
            code: product.code,
            sku_info: [
              {
                vendas: null,
                inventory: product.stock,
                minimum_stock: null,
                measures: product.measures,
              },
            ],
          };
        }),
        totalDiscount: floatToCents(await orderContext.getDiscountGeneral()),
      };
      const objCustomerCart = {
        customerName: customerName,
        cpfCustomer: cpfCnpjNoMask(customerCpf),
        phoneCustomer: telephoneNoMask(customerPhone),
        cpfSeller: tk?.identifier,
        jsonCart: jsonCart,
        locationId: order.products[0].locationId,
        urlcart: link + "?cart=",
      };
      await api
        .post(`/api/customerCart`, objCustomerCart, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          if (response.status === 201) {
            setCustomerToSeller({
              id: response.data.dados.id,
              name: customerName,
              phone: telephoneNoMask(customerPhone),
              cpf: cpfCnpjNoMask(customerCpf),
              url: link + "?cart=" + response.data.dados.guid,
              guid: response.data.dados.guid,
            });
            clearOrder();
            navigate(`/${pluginspace_id}/seller-qrcode`);
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro ao criar carrinho",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Verifique se preencheu todos os campos",
      });
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      className="modal-seller-cart"
      contentLabel="Gravar carrinho"
      overlayClassName="overlay-modal"
      ariaHideApp={false}
    >
      <div className="modal-seller-cart-content">
        <div className="modal-seller-cart-body">
          <div className="title">
            <h2>Gravar carrinho</h2>
            <svg
              onClick={() => setIsOpen(false)}
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.978551 2.97126L6.957 8.94971L0.978551 14.9282L2.97137 16.921L8.94981 10.9425L14.9283 16.921L16.9211 14.9282L10.9426 8.94971L16.9211 2.97126L14.9283 0.978446L8.94981 6.95689L2.97137 0.978446L0.978551 2.97126Z"
                fill="#636363"
              />
            </svg>
          </div>
          <div className="modal-seller-form">
            <div>
              <p className="info">
                Informe todos os dados do cliente para salvar o carrinho.
              </p>

              <InputMask
                mask={maskCpfjCnpj}
                type="text"
                placeholder="Informe o CPF *"
                value={customerCpf}
                onBeforeInputCapture={(event) =>
                  changeMaskCpf(event.currentTarget.value)
                }
                onChange={(event) => setCustomerCpf(event.target.value)}
                onBlur={() =>
                  customerCpf[1] === "_"
                    ? setAlarmCpf(true)
                    : setAlarmCpf(false)
                }
                style={{
                  border: alarmCpf ? "1px solid red" : "1px solid #636363",
                }}
              />
              {alarmCpf && <p className="alarm-text">CPF é obrigatório</p>}
              <input
                placeholder="Informe o nome *"
                type="text"
                value={customerName}
                onChange={(event) => setCustomerName(event.target.value)}
                onBlur={() =>
                  customerName === "" ? setAlarmName(true) : setAlarmName(false)
                }
                style={{
                  border: alarmName ? "1px solid red" : "1px solid #636363",
                }}
              />
              {alarmName && <p className="alarm-text">Nome é obrigatório</p>}
              <InputMask
                mask={maskTelephone}
                placeholder="Informe o celular *"
                type="text"
                value={customerPhone}
                onBeforeInputCapture={(event) =>
                  changeTelephone(event.currentTarget.value)
                }
                onChange={(event) => setCustomerPhone(event.target.value)}
                onBlur={() =>
                  customerPhone[1] === "_"
                    ? setAlarmPhone(true)
                    : setAlarmPhone(false)
                }
                style={{
                  border: alarmPhone ? "1px solid red" : "1px solid #636363",
                }}
              />
              {alarmPhone && (
                <p className="alarm-text">Telefone é obrigatório</p>
              )}
            </div>
            <div>
              <MainButton
                color={fontButton ? fontButton : "#636363"}
                backgroundColor={
                  backgroundButton ? backgroundButton : "#EAEAEA"
                }
                text="Gravar carrinho"
                onClick={() => saveCart()}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
